import styled from 'styled-components';
export var DateTagLabel = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-8cdd77-0"
})(["\n  box-shadow: 0 0 16px rgba(227, 228, 229, 0.18),\n    0 4px 8px rgba(187, 188, 191, 0.18);\n"]);